const Style = {
    page: 'mx-auto max-w-4xl px-6 py-12 sm:py-16',
    notFound: 'mx-auto flex max-w-lg flex-col items-center px-6 py-16 text-center',
    card: 'mx-auto w-full max-w-4xl !mb-0',

    header: 'mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between',
    identity: 'flex min-w-0 gap-4',
    identityCopy: 'min-w-0 space-y-1',
    eyebrow: 'text-xs font-medium uppercase tracking-wide text-text-muted',
    title: 'text-xl font-semibold leading-tight text-text-primary sm:text-2xl',
    subtitle: 'text-sm text-text-secondary',

    headerActions: 'shrink-0 sm:pt-1 sm:text-right',
    dashLink:
        'text-sm font-medium text-primary-600 underline-offset-4 hover:underline dark:text-primary-400',
    dashError: 'mt-2 max-w-xs text-sm text-error sm:ml-auto',
};

export default Style;
